import { Injectable } from '@angular/core';

import 'rxjs/add/operator/map';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import { Observable } from 'rxjs/Observable';
import { Constants } from './app.constants';
import { Router, CanActivate,ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LocalstorageService } from './localstorage.service';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { GlobalEventMangerService } from './global-event-manger.service';

@Injectable()
export class AutologoutService {
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  constructor(private http: HttpClient, private _constants: Constants, private idle: Idle, private keepalive: Keepalive, private router: Router, private globalEventMangerService: GlobalEventMangerService, private localStorageService: LocalstorageService) {
      // sets an idle timeout of 5 seconds, for testing purposes.
      this.idle.setIdle(300);
      // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
      this.idle.setTimeout(5);
      // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
  
      this.idle.onIdleEnd.subscribe(() => this.idleState = 'No longer idle.');
      this.idle.onTimeout.subscribe(() => {
          // this.localStorageService.setData("currentUser", '');
          // this.globalEventMangerService.showNavBar(false);
          // this.router.navigate(['/login']);
          return false;
      });
      this.idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone idle!');
      this.idle.onTimeoutWarning.subscribe((countdown) => this.idleState = 'You will time out in ' + countdown + ' seconds!');
  
      // sets the ping interval to 15 seconds
      this.keepalive.interval(15);
  
      this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
      this.reset();    
  }
  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
}


// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/autologout.service.ts